import { encode as encodeAbi } from '@findeth/abi';
export const encode = (types, values) => {
  return encodeAbi(types, values);
};
//# sourceMappingURL=abi.js.map